import _ from 'lodash';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import 'datatables.net-buttons-dt';
import { DataTableDirective } from 'angular-datatables';
import { WebHookFormModalService } from '../../services/web-hook-form-modal/web-hook-form-modal.service';
import { select, Store } from '@ngrx/store';
import * as WebHookActions from '../../features/webhook-actions'
import * as WebHookSelectors from '../../features/webhook-selectors'

@Component({
  selector: 'app-web-hook-list',
  templateUrl: './web-hook-list.component.html',
  styleUrls: ['./web-hook-list.component.scss'],
})
export class WebHookListComponent implements OnInit, OnDestroy {
  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  @ViewChild(DataTableDirective, {static: false})
  public dtElement: DataTableDirective;

  public dtOptions: ADTSettings = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  
  public webHookList: any[];
  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService,
    private webHookFormModalService: WebHookFormModalService,
    private store: Store,
  ) {}

  public webHookListSelector$ = this.store.pipe(
    select(WebHookSelectors.selectWebHookList$)
  )

  ngOnInit(): void {
    this.store.dispatch({
      type:WebHookActions.loadWebHookList.type
    });

    this.webHookListSelector$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response) => {
      this.webHookList = response;
    });

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

    });
  }
 
  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

  addWebHook() {
    this.webHookFormModalService.editOrAddWebHook(null);
  }
}
